import UtilsService from './utils-service';

/***
 * A Service that contains utility functions that can be used across the app.
 */
const utils = angular
    .module('FacilityData.Common.Utils', [])
    .service('Utils', UtilsService)
    .name;

export default utils;


// WEBPACK FOOTER //
// ./app/common/utils/utils.js